import get from 'lodash/get';
import {
  FETCH_PQT_ELEMENTS,
  FETCH_PQT_ELEMENTS_SUCCESS,
  FETCH_PQT_ELEMENTS_FAILURE,
  FETCH_PROJECT_PQT_REPORT,
  FETCH_PROJECT_PQT_REPORT_SUCCESS,
  FETCH_PROJECT_PQT_REPORT_FAILURE,
  UPDATE_PROJECT_PQT_REPORT,
  UPDATE_PROJECT_PQT_REPORT_SUCCESS,
  UPDATE_PROJECT_PQT_REPORT_FAILURE,
  CREATE_PROJECT_PQT_REPORT,
  CREATE_PROJECT_PQT_REPORT_SUCCESS,
  CREATE_PROJECT_PQT_REPORT_FAILURE,
  FETCH_DSR_LOG_PQT,
  FETCH_DSR_LOG_PQT_SUCCESS,
  FETCH_DSR_LOG_PQT_FAILURE,
  UPDATE_DSR_LOG_PQT,
  UPDATE_DSR_LOG_PQT_SUCCESS,
  UPDATE_DSR_LOG_PQT_FAILURE,
} from './types';

const initialState = {
  pqtElements: [],
  report: null,
  isPqtElementsLoading: false,
  isReportLoading: false,
  isUpdateLoading: false,
  dsrLogPqt: { pqt: null, elements: [], toDate: null },
  isDsrLogPqtLoading: false,
  isDsrLogPqtUpdating: false,
  lastDsrLogPqtUpdateSuccess: null,
};

const projectPqtReportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PQT_ELEMENTS: {
      return { ...state, isPqtElementsLoading: true };
    }
    case FETCH_PQT_ELEMENTS_SUCCESS: {
      const pqtElements = get(action, 'pqtElements', []);
      return {
        ...state,
        pqtElements,
        isPqtElementsLoading: false,
      };
    }
    case FETCH_PQT_ELEMENTS_FAILURE: {
      return { ...state, isPqtElementsLoading: false };
    }
    case FETCH_PROJECT_PQT_REPORT: {
      return { ...state, isReportLoading: true };
    }
    case FETCH_PROJECT_PQT_REPORT_SUCCESS: {
      const report = get(action, 'report', null);
      return {
        ...state,
        report,
        isReportLoading: false,
      };
    }
    case FETCH_PROJECT_PQT_REPORT_FAILURE: {
      return { ...state, isReportLoading: false };
    }
    case UPDATE_PROJECT_PQT_REPORT: {
      return { ...state, isUpdateLoading: true };
    }
    case UPDATE_PROJECT_PQT_REPORT_SUCCESS: {
      const response = get(action, 'response', {});
      return {
        ...state,
        report: response,
        isUpdateLoading: false,
      };
    }
    case UPDATE_PROJECT_PQT_REPORT_FAILURE: {
      return { ...state, isUpdateLoading: false };
    }
    case CREATE_PROJECT_PQT_REPORT: {
      return { ...state, isUpdateLoading: true };
    }
    case CREATE_PROJECT_PQT_REPORT_SUCCESS: {
      const response = get(action, 'response', {});
      return {
        ...state,
        report: response,
        isUpdateLoading: false,
      };
    }
    case CREATE_PROJECT_PQT_REPORT_FAILURE: {
      return { ...state, isUpdateLoading: false };
    }
    case FETCH_DSR_LOG_PQT: {
      return { ...state, isDsrLogPqtLoading: true };
    }
    case FETCH_DSR_LOG_PQT_SUCCESS: {
      const pqt = get(action, 'pqt', null);
      const elements = get(action, 'elements', []);
      const toDate = get(action, 'toDate', null);
      return {
        ...state,
        dsrLogPqt: { pqt, elements, toDate },
        isDsrLogPqtLoading: false,
      };
    }
    case FETCH_DSR_LOG_PQT_FAILURE: {
      return { ...state, isDsrLogPqtLoading: false };
    }
    case UPDATE_DSR_LOG_PQT: {
      return { ...state, isDsrLogPqtUpdating: true, lastDsrLogPqtUpdateSuccess: null };
    }
    case UPDATE_DSR_LOG_PQT_SUCCESS: {
      const response = get(action, 'response', {});
      const pqt = get(response, 'pqt', state.dsrLogPqt?.pqt);
      const elements = Array.isArray(get(response, 'elements')) ? response.elements : state.dsrLogPqt?.elements ?? [];
      const toDate = get(response, 'toDate', state.dsrLogPqt?.toDate ?? null);
      return {
        ...state,
        isDsrLogPqtUpdating: false,
        lastDsrLogPqtUpdateSuccess: true,
        dsrLogPqt: { pqt, elements, toDate },
      };
    }
    case UPDATE_DSR_LOG_PQT_FAILURE: {
      return { ...state, isDsrLogPqtUpdating: false, lastDsrLogPqtUpdateSuccess: false };
    }
    default: {
      return state;
    }
  }
};

export default projectPqtReportsReducer;
